import { gql } from '@apollo/client';

export const NAVIGATION_ACTION = gql`
  query navigationAction {
    navigationAction @client
  }
`;
